module.exports = __webpack_public_path__ + "media/images/workflow-add-0ef9eb2a8d996b83ecd24eae4a9e987f.svg";